import { render, staticRenderFns } from "./transformationProductionSwitch.vue?vue&type=template&id=7878a992&scoped=true"
import script from "./transformationProductionSwitch.vue?vue&type=script&lang=js"
export * from "./transformationProductionSwitch.vue?vue&type=script&lang=js"
import style0 from "./transformationProductionSwitch.vue?vue&type=style&index=0&id=7878a992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878a992",
  null
  
)

export default component.exports